$(function () {
  document.addEventListener('scroll', function() {
    if (document.documentElement.scrollTop > $(window).height()) {
      $('.mini-header').fadeIn();
    } else {
      $('.mini-header').fadeOut();
    }
  });

  $('.back-to-top').click(function () {
    event.preventDefault();

    $('html,body').animate({scrollTop: 0}, 500);
  });
});
